import { fetchMessages } from "@/services/api/apiServiceMessages"; // Adjust the path as needed
import { useToast } from "vue-toastification";

export default {
  namespaced: true,
  state: {
    messages: [],
    whatsappMessages: [],
  },
  mutations: {
    setMessages(state, messages) {
      state.messages = messages;
    },
    setWhatsapp(state, messages) {
      state.whatsappMessages = messages;
    },
  },
  actions: {
    async getMessages({ commit }) {
      const toast = useToast();
      try {
        const messages = await fetchMessages("sms");
        commit("setMessages", messages.data);
        return messages;
      } catch (err) {
        toast.error("بارگزاری پیام ها با مشکل موجه شد!");
        throw err;
      }
    },
    async getWhatsappMessages({ commit }) {
      const toast = useToast();
      try {
        const messages = await fetchMessages("whatsapp");
        commit("setWhatsapp", messages.data);
        return messages;
      } catch (err) {
        toast.error("بارگزاری پیام ها با مشکل موجه شد!");
        throw err;
      }
    },
  },
  getters: {},
};
